import config from 'config';
import * as http from 'utils/http';
import serialize from 'utils/serialize';
import { adaptFiltersForBackend } from './filters/filter-computations';

export async function fetchTasks({ pageNumber, filters }) {
  const filtersQuery = serialize(adaptFiltersForBackend(filters));

  return http.get(
    `${config.API_URL}mercury/journey_summaries/?page=${pageNumber}&page_size=50&${filtersQuery}`
  );
}

export async function searchOrderId(id) {
  try {
    return await http.get(`${config.API_URL}search/?term=${id}`);
  } catch (e) {
    console.error('Error while searching order ID', e);
  }
}

export async function createTask(params) {
  try {
    return await http.post(`${config.BASE_URL}/api/tasks/`, params);
  } catch (e) {
    console.error(e);
  }
}

export async function assignJourneyOwner({ journeyId, agentId, ids }) {
  const URL_ONE_JOURNEY = `${config.API_URL}mercury/journeys/${journeyId}/handlers/${agentId}/`;
  const URL_MULTIPLE_JOURNEYS = `${config.API_URL}mercury/journeys/bulk_update/handler`;

  try {
    if (!ids) return await http.put(URL_ONE_JOURNEY);
    return await http.put(URL_MULTIPLE_JOURNEYS, {
      handler_id: agentId,
      journey_ids: ids,
    });
  } catch (e) {
    console.error('Error assigning journey owner: ', e);
  }
}

export async function getJourneyOwner(journeyId) {
  const res = await http.get(`${config.API_URL}mercury/journeys/${journeyId}/handlers/`);

  const { id, name } = res || {};

  if (!id) return null;
  return {
    id,
    label: name,
  };
}

export async function changeTaskStatus({ taskId, status }) {
  const statuses = {
    pending: 'pending',
    review: 'review',
    solve: 'solve',
  };

  try {
    return await http.put(`${config.BASE_URL}/api/tasks/${taskId}/${statuses[status]}/`);
  } catch (e) {
    console.error('Error changing task status: ', e);
  }
}
